module.exports = __webpack_public_path__ + "static/media/search.23887038.svg";